'use client';

import 'BomdisoftComponents/layout/styles.css';
import { type ReactNode } from 'react';

export const LayoutContentSlot = ({ children }: { children: ReactNode }) => {
  return (
    <div className='bomdisoft-layout-content-slot' data-testid='layout-content'>
      {children}
    </div>
  );
};
